import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { dltUcetRegExp } from 'enums/regExp';

export const dltUcetValidation = () => [
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || dltUcetRegExp.test(value)) return Promise.resolve();
            return Promise.reject(<TranslateText>NEVALIDNI_UCET</TranslateText>);
        }
    })
];

export default dltUcetValidation;
